<template>
  <LoadingIndicator 
      v-if="loading"
      topic="Users"
    />
  <div v-else>
    <b-row class="justify-content-end">
      <b-col>
        <div v-if="hideQr">
          <qr-code
            id="codeQr"
            :text="qrCodeUrl"
            :size="100"
            color="#000000"
            bg-color="#ffffff"
            error-level="L"
            tag="img"
          >
          </qr-code>
        </div>
        <b-button-group>
          <b-button
            variant="link"
            class="pl-0"
            @click="copyRegistration"
          >
            <b-icon icon="link45deg"></b-icon>
            Copy registration link
          </b-button>
          <b-button variant="link" @click="downloadImage()">
            <b-icon icon="download"></b-icon>
            Download QR code
          </b-button>
        </b-button-group>
      </b-col>
      <b-col cols="auto">
        <ReinviteAllUsersButton
          :projectId="projectId"
        ></ReinviteAllUsersButton>
      </b-col>
      <b-col cols="auto">
        <ExportAllUsersButton
          :projectId="projectId"
        ></ExportAllUsersButton>
      </b-col>
      <b-col cols="auto">
        <AddProjectUserButton
          v-if="projectUsers && allOrganizations"
          :projectId="projectId"
          :organizations="allOrganizations"
          :users="projectUsers"
          @update="refreshAddUserData"
        ></AddProjectUserButton>
      </b-col>
    </b-row>
    <UserTable
      :projectUsers="usersWithCharterData"
      :projectId="projectId"
      @update="refreshProjectUsers"
    ></UserTable>
    <b-alert
      v-model="copyAlertCountDown"
      class="position-fixed"
      style="bottom: 0; left: calc(50% - 113px)"
      variant="dark"
      dismissible
      fade
      @dismissed="copyAlertCountDown = 0"
      @dismiss-count-down="countDownChanged"
      >Copied registration link</b-alert
    >
  </div>
</template>

<script>
import axios from "axios";
// import { mapGetters } from "vuex";

import Vue from "vue";
import VueQRCodeComponent from "vue-qrcode-component";
import QRCode from "qrcode";

import ReinviteAllUsersButton from "@/components/project/ReinviteAllUsersButton.vue";
import ExportAllUsersButton from "@/components/project/ExportAllUsersButton.vue";
import AddProjectUserButton from "@/components/project/AddProjectUserButton.vue";
import UserTable from "@/components/project/UserTable.vue";

Vue.component("qr-code", VueQRCodeComponent);
export default {
  components: {
    ReinviteAllUsersButton,
    ExportAllUsersButton,
    AddProjectUserButton,
    UserTable,
  },
  props: {
    projectSummary: { type: Object, required: true }
  },
  data() {
    return {
      hideQr: false,
      allOrganizations: null,
      projectUsers: null,
      allProjectUsers: [],
      loadingProjectUsers: false,
      loadingAllUsers: false,
      loadingOrganizations: false,
      copyAlertCountDown: 0,
      errors: [],
    }
  },
  computed: {
    // ...mapGetters({
    //   isLoading: 'getDataLoading',
    //   hasLoaded: 'getDataLoaded',
    // }),
    loading() {
      return this.loadingProjectUsers || 
        this.loadingAllUsers || 
        this.loadingOrganizations;
    },
    project() {
      return this.projectSummary.project;
    },
    projectId() {
      return this.project.projectId;
    },
    qrCodeUrl() {
      return `${window.location.origin}/sign-up?pid=${this.projectId}`;
    },
    usersWithCharterData() {
      // const approvedCharters = this.projectSummary.charterRelations.filter(user => user.approveCharterDate);
      if (!this.projectUsers) {
        return [];
      }
      
      const usersWithCharterData = this.projectUsers.map(user => {
        const matchingCharter = this.projectSummary.charterRelations.find(charter => user.userId === charter.userId);
        return {
          ...user,
          userCharterId: matchingCharter ? matchingCharter.userCharterId : null,
          approveCharterDate: matchingCharter ? matchingCharter.approveCharterDate : null
        }
      });
      return usersWithCharterData;
    },
  },
  watch: {

  },
  mounted() {
    // this.loadData();
    this.setupUserData();
  },
  methods: {
    setupUserData() {
      this.projectUsers = this.projectSummary.projectUsers;
      this.loadAllOrganizations();
    },
    copyRegistration() {
      navigator.clipboard.writeText(
        `${window.location.origin}/sign-up?pid=${this.projectId}`
      );
      this.copyAlertCountDown = this.copyAlertSecs;
    },
    countDownChanged(dismissCountDown) {
      this.copyAlertCountDown = dismissCountDown;
    },
    downloadImage() {
      this.hideQr = true;
      QRCode.toDataURL(this.qrCodeUrl)
        .then((url) => {
          var link = document.getElementById("codeQr");
          var img = document.createElement("img");
          img.src = url;
          var a = document.createElement("a");
          a.href = img.src;
          a.download = `${this.projectName} QrCode`;
          a.appendChild(img);
          link.appendChild(a);
          a.click();
          a.remove();
          this.hideQr = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    refreshAddUserData() {
      this.refreshProjectUsers();
      this.loadAllUsers();
      //Adding a user can also create an organization, so they need to be updated!
      this.loadAllOrganizations();
    },
    refreshProjectUsers() {
      this.loadingProjectUsers = true;
      axios
        .get(
          `${this.$api_url}/projects/${this.projectId}/users`,
          this.getReqConfig()
        )
        .then((response) => {
          this.projectUsers = response.data;
        })
        .catch((err) => {
          this.errors.push(err);
        })
        .finally(() => {
          this.loadingProjectUsers = false;
        });
    },
    loadAllUsers() {
      this.loadingAllUsers = true;
      axios
        .get(
          `${this.$api_url}/projects/${this.projectId}/users?inactiveUsers=true&periodId=${this.periodName}`,
          this.getReqConfig()
        )
        .then((response) => {
          this.allProjectUsers = response.data;
        })
        .catch((err) => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.loadingAllUsers = false;
        });
    },
    loadAllOrganizations() {
      this.loadingOrganizations = true;
      axios
        .get(`${this.$api_url}/organizations`, this.getReqConfig())
        .then((response) => {
          this.allOrganizations = response.data;
        })
        .catch((err) => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.loadingOrganizations = false;
        });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
